import {
  ErrorFormCommissioningEnum,
  ErrorStepsEnum
} from '@bo-client/activation-management/shared/forms/create-forms-errors-model';

export class ShowErrorModel {
  controlName = '';
  displayName = '';
  errorMessage = '';
  comment?: string = '';
  step?: ErrorStepsEnum;

  public static toReadableString(showErrorModel: ShowErrorModel) {
    return showErrorModel.displayName + ' ' + showErrorModel.errorMessage;
  }
}
